module.exports = __webpack_public_path__ + "static/media/vpa.65765bad.jpg";